function Seconds(x) {
    const last_digit = x %  10;

    // 11,12,13,14 - исключения
    if ( x>10 && x < 15 )
        return x + ' секунд';

    switch(last_digit){
        case 1:
            return x + ' секунда';
        case 2:
        case 3:
        case 4:
            return x + ' секунды';
        default:
            return x + ' секунд';
    }
}

function Minutes(x) {
    const last_digit = x %  10;

    // 11,12,13,14 - исключения
    if ( x>10 && x < 15 )
        return x + ' минут';

    switch(last_digit){
        case 1:
            return x + ' минута';
        case 2:
        case 3:
        case 4:
            return x + ' минуты';
        default:
            return x + ' минут';
    }
}

export default function TimeLeft(mseq) {
    const fsecs  = mseq / 1000;
    const fhours = fsecs / 3600;
    const fmins  = fsecs / 60;
    
    const hours  = Math.floor(fhours);
    const mins   = Math.floor(fmins) % 60;
    const secs   = Math.floor(fsecs) % 60;

    if (fhours >= 5)
        return (hours + " часов"); // следующий падеж - 21 час, не поддерживаем пока
    else if (fhours >= 2)
        return (hours + " часа " + Minutes(mins));
    else if (fhours >= 1)
        return ("1 час " + Minutes(mins));
    else if (mins >= 3)
        return Minutes(mins);
    else if (mins >= 1)
        return (Minutes(mins) + ' ' + Seconds(secs));
    else
        return (Seconds(secs));

}

/*
function test (h,m,s,ms){
    let output = h+':'+m+':'+s+'('+ms+') ' 
        + TimeLeft(ms+1000*(s+60*(m+60*h)));
    console.log(output);
}

test(10,45,5,123);
test(4,45,5,123);
test(3,45,5,123);
test(2,45,5,123);
test(1,45,5,123);
test(0,45,5,123);
test(0,43,5,123);
test(0,41,5,123);
test(0,11,5,123);
test(0,3,0,123);
test(0,2,1,123);
test(0,2,2,123);
test(0,2,3,123);
test(0,2,5,123);
test(0,1,5,123);
test(0,0,5,123);
test(0,0,3,123);
test(0,0,1,123);
test(0,0,0,0);
*/

